import Vue from "vue";
import Vuex from "vuex";
import {array_move} from "./common"
import { v4 as uuidv4 } from 'uuid';

Vue.use(Vuex);

const  add = (state) => {
    

    state.counter = ++state.counter;
    let newArr = [];
    state.canvasInstances[state.activeCanvasIndex].objects.map(x => newArr.push(x))
    state.history[state.counter] = [...newArr];

    // delete anything forward of the counter
    state.history.splice(state.counter+1);
}

export default new Vuex.Store({
state:{
    showlayersPanel: false,
    history:[],
    counter:-1,
    currentActiveSidePanel: "Templates",
    activeObject: null,
    canvasInstances: [
        {
            id:`canvas_${uuidv4()}`,
            size:{
                width:1920,
                height:1080
            },
            zoomRatio:1,
            bgColor:"#fff",
            slideDuration: 20,
            objects:[],
        }
    ],
    activeCanvasIndex : 0,
    activeObjectprops:null,
    createShape:""
},
getters:{
   
    getCanvasInstances: state => {
        return state.canvasInstances;
    },
    getCanvasRefs: state => {
        return state.canvasRefs;
    },
    getCanvasIndex: state => {
        return state.activeCanvasIndex;
    },
    getCurrentActiveCanvas: state => {
        if(state.canvasInstances[state.activeCanvasIndex]){

            return state.canvasInstances[state.activeCanvasIndex];
        }
    },
    getCurrentActiveCanvasObjects: state => {
        if(state.canvasInstances[state.activeCanvasIndex]){

            return state.canvasInstances[state.activeCanvasIndex].objects;
        }
    },
    getCurrentActiveSize: state => {
        if(state.canvasInstances[state.activeCanvasIndex]){

            return state.canvasInstances[state.activeCanvasIndex].size;
        }
    },
    getActiveObject: state => {
         return state.activeObject;
    },
    getActiveObjectprops: state => {
         return state.activeObjectprops
    },
    getZoom:state => {
        return state.canvasInstances[state.activeCanvasIndex].zoomRatio;
    },
    getActiveSidePanel:state => {
        return state.currentActiveSidePanel
    },
    getcreateShapeType:state => {
        return state.createShape
    },
    getShowLayersPanel:state => {
        return state.showlayersPanel
    }
    
},
mutations:{
   
    undo(state){
        
        state.counter = --state.counter;
        if(state.history[state.counter]){
            state.canvasInstances[state.activeCanvasIndex].objects = state.history[state.counter]

        } else {
            state.counter = -1
            state.canvasInstances[state.activeCanvasIndex].objects = []

        }
    },
    redo (state){
        
        state.counter = ++state.counter;
        if(state.history[state.counter]){
            state.canvasInstances[state.activeCanvasIndex].objects = state.history[state.counter]

        } else {
            state.counter = state.history.length
            state.canvasInstances[state.activeCanvasIndex].objects = state.history.at(-1) === undefined ? [] : state.history.at(-1)
        }
    },
    SET_ACTIVE_SIDEPANEL(state,value){
        

        state.currentActiveSidePanel = value
    },
    SET_CANVAS_INSTANCE(state,value){
        

        console.log("SET_CANVAS_INSTANCE")
        state.canvasInstances.push(value)
       
    },
    SET_CANVAS_REFS(state,value){
        Object.keys(value).forEach( key => {
            Vue.set(state.canvasRefs, key, value[key])
          })        
    },
    SET_CANVAS_INDEX(state,value){
        state.activeCanvasIndex = value;
        state.history = []
    },
    SET_ACTIVEOBJECT(state,value){
        
        let currentID = value?.id; 
        let index = state.canvasInstances[state.activeCanvasIndex].objects.findIndex(x => x.id === currentID);
        if(index !== -1){
            state.activeObjectprops =  state.canvasInstances[state.activeCanvasIndex].objects[index]
        }
            state.activeObject = value;
       
    },
    SET_CANVAS_DIMENSIONS(state,value){
         state.canvasInstances[state.activeCanvasIndex].size = value
    },
    SET_CANVAS_OBJECT(state,value){
         state.canvasInstances[state.activeCanvasIndex].objects.push(value)
         console.log(state.canvasInstances)
         add(state)
    },
    SET__OBJECT_PROPERTIES(state,value){
      
         let currentID = state.activeObject?.id;
         let index = state.canvasInstances[state.activeCanvasIndex].objects.findIndex(x => x.id === currentID);
         if(index !== -1){
            let currentObj = state.canvasInstances[state.activeCanvasIndex].objects[index];
            let newobj = {...currentObj , ...value};
            state.canvasInstances[state.activeCanvasIndex].objects[index] = newobj;
            state.canvasInstances =  [...state.canvasInstances];
            state.activeObjectprops = newobj;
            add(state)
         }
    },
    DELETE_OBJECT(state,value){
        let currentID = value;
        if(currentID){
            let ObjectsList = state.canvasInstances[state.activeCanvasIndex].objects.filter(x => x.id !== currentID);
            state.canvasInstances[state.activeCanvasIndex].objects = ObjectsList;
            state.canvasInstances =  [...state.canvasInstances];
            state.activeObject = null;
            state.activeObjectprops = null;
            state.currentActiveSidePanel= "Templates"
            add(state)
        }
        
    },
    REPOSITION_OBJECTS(state,value){
        let currentArr = [];
        state.canvasInstances[state.activeCanvasIndex].objects.map(x => {

            currentArr.push(x);
        });
        let newList = array_move(currentArr,value.oldindex,value.newIndex);
        Vue.set(state.canvasInstances[state.activeCanvasIndex], 'objects', newList);
        // state.canvasInstances[state.activeCanvasIndex].objects = newList;
        add(state)
    },
    SET_ZOOM(state,value){
        state.canvasInstances[state.activeCanvasIndex].zoomRatio = value
    },
    DUPLICATE_CANVAS(state,value){
        
        state.canvasInstances.splice(value.index + 1 , 0 , value.newObj);
    },
    REMOVE_CANVAS(state,value){
        let newArr = state.canvasInstances.filter(x => x.id !== value);
        state.canvasInstances = newArr
    },
    SET_CREATESHAPE(state,value){
        state.createShape = value
    },
    SET_LAYERS_WINDOW(state,value){
        state.showlayersPanel = value
    },
    SET_CANVAS_DURATION(state,value) {
        state.canvasInstances[state.activeCanvasIndex].slideDuration = value
    }
},
actions:{
  
    addObjectInCanvas({commit} , value){
        
        commit('SET_CANVAS_OBJECT' , value)
    },
    setCanvasInstance({commit} , value){
        commit('SET_CANVAS_INSTANCE' , value)
    },
    duplicateCanvas({commit} , value){
        commit('DUPLICATE_CANVAS' , value)
    },
    removeCanvas({commit} , value){
        commit("REMOVE_CANVAS",value)
    },
    setActiveCanvasIndex({commit} , value) {
        commit('SET_CANVAS_INDEX' , value);
    },
    setActiveObject({commit} , object){
        
        commit('SET_ACTIVEOBJECT' , object)
    },
    setCurrentCanvasDimensions({commit} , value ){
        commit('SET_CANVAS_DIMENSIONS' , value)
    },
    setCurrentObjectProperties({commit} , value ){
        commit('SET__OBJECT_PROPERTIES' , value)
    },
    deleteObject({commit},value){
        commit('DELETE_OBJECT',value)
    },
    zIndexObjects({commit},value){
        
        commit("REPOSITION_OBJECTS",value)
    },
    setZoom({commit},value){
        commit("SET_ZOOM",value)
    },
    set_active_sidepanel({commit},value){
        commit("SET_ACTIVE_SIDEPANEL",value)
    },
    set_newText({commit},value){
        commit("SET_ACTIVE_SIDEPANEL",value)
    },
    undo({commit},){
        commit("undo")
    },
    redo({commit},){
        commit("redo")
    },
    createShape({commit},value){
        commit("SET_CREATESHAPE",value)
    },
    setShapeSetting({commit},value){
        commit("SET_ACTIVESHAPEWIDTHANDHEIGHT",value)
    },
    toggleLayerPanel({ commit } , value) {
        commit('SET_LAYERS_WINDOW', value);
      },
      setSlideDuration({commit}, value) {
        commit('SET_CANVAS_DURATION', value)
      }
}


})